<template>
  <section class="section subcategories">
    <div class="subcategories__container">
      <div class="subcategories__list">
        <div class="subcategories__item">
          <div class="subcategories-card">
            <div class="subcategories-card__title">{{ fullTitle }}</div>
            <span class="subcategories-card__show icon-link">
                      <svg class="icon-link__icon" aria-hidden="true">
                        <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-next"></use>
                      </svg>
                    </span>
            <a class="subcategories-card__link" href="#" @click.prevent="setCurrentFormView('fullForm')"></a>
          </div>
        </div>
        <div class="subcategories__item">
          <div class="subcategories-card">
            <div class="subcategories-card__title">{{ shortTitle }}</div>
            <span class="subcategories-card__show icon-link">
                      <svg class="icon-link__icon" aria-hidden="true">
                        <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-next"></use>
                      </svg>
                    </span>
            <a class="subcategories-card__link" href="#" @click.prevent="setCurrentFormView('shortForm')"></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {useIndividualPacking} from "@/hooks/useIndividualPacking";

export default {
  name: "IPViews",
  mixins: [useIndividualPacking],
  props: {
    fullTitle: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_FULL_TITLE')
    },
    shortTitle: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_SHORT_TITLE')
    },
  }
}
</script>

<style scoped>

</style>